import { useLazyQuery } from "@apollo/client";

import { UserQuery, UserQueryVariables } from "@ctypes";
import { USER } from "@graphql";

export const useFetchUser = () => {
  return useLazyQuery<UserQuery, UserQueryVariables>(USER, {
    fetchPolicy: "network-only",
  });
};
